
import AppBox from '@/components/AppBox.vue'
import AppInput from '@/components/AppInput.vue'
import AppTable from '@/components/AppTable.vue'
import { Component, Vue } from 'vue-property-decorator'
import { ChildComponentMixin } from '@/mixins'
import AppButton from '@/components/AppButton.vue'
@Component({
    components: {
        AppBox,
        AppInput,
        AppTable,
        AppButton,
    },
})

export default class QueriesSavedQueries extends Vue {
    public search: string = ''

    get headers(): string[] {
        return ['Nome', 'Descrição', 'Query', 'Criado por']
    }

    get rows(): object[] {
        return this.$store.state.query.savedQueries
    }

    public filterSavedQueries() {
        this.$store.dispatch('query/filterSavedQueries', this.search)
    }
}
